import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { useEffect, useState } from "react"
import { Pagination } from "../../../ui/organisms/pagination"
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo"
import { GetAllValutazioni, setGetAllValutazioniValM24User, setGetAllValutazioniValType, setGetAllValutazioniValVisitUser } from "./slice"
import { MonitoringValutazioniListM24 } from "./listM24"
import { SelectCustom } from "../../../ui/molecules/select"
import { ValTypeOptions, yearOptions } from "../../../utils"
import { MonitoringValutazioniListVisits } from "./listVisits"
import { MonitoringValutazioniListVisitsM24 } from "./listVisitsM24"

export function MonitoringValutazioni() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const valutazioniState = useAppSelector(state => state.valutazioniMonitoring)
    const [showM24Select, setShowM24Select] = useState<boolean>(false)
    const [showVisitsSelect, setShowVisitsSelect] = useState<boolean>(false)
    const [showBothSelect, setShowBothSelect] = useState<boolean>(false)

    useEffect(() => {
        if (valutazioniState.GetAllValutazioniFilters.valType === 'M24') {

            setShowM24Select(true)
            setShowVisitsSelect(false)
            setShowBothSelect(false)
        }
        if (valutazioniState.GetAllValutazioniFilters.valType === 'VISITE') {
            setShowM24Select(false)
            setShowVisitsSelect(true)
            setShowBothSelect(false)
        }
        if (valutazioniState.GetAllValutazioniFilters.valType === 'VISITE_M24') {
            setShowM24Select(false)
            setShowVisitsSelect(false)
            setShowBothSelect(true)
        }
    }, [valutazioniState.GetAllValutazioniFilters.valType])

    if (valutazioniState.getAllValutazioniStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }
    return (
        <Layout menuItem={MenuItems.GESTIONE_CONTROLLO} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Monitoraggio Fase di Avvio']}
            noPaddingLat
            headerLabel="Monitoraggio Valutazioni"
        >
            <div style={{ padding: '24px' }}>
                <div className="w-[100%] flex flex-col gap-[16px] filter" style={{ padding: '24px 0px 0px 0px' }}>
                    <div className="flex flex-row gap-[16px]" style={{ flex: 1, alignItems: 'center' }}>
                        <div style={{ justifyContent: 'left', flex: 1 }} className="flex gap-[16px] items-center">
                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    // key={pacState.getAllPACDetailsFilters.year || 'default'}
                                    placeholder={'Anno'}
                                    label="Anno"
                                    // value={String(pacState.getAllPACDetailsFilters.year)}
                                    options={yearOptions}
                                    onChange={(value) => console.log(value)}
                                />
                            </div>
                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    // key={pacState.getAllPACDetailsFilters.year || 'default'}
                                    placeholder={'Tipo Valutazione'}
                                    label="Tipo Valutazione"
                                    // value={String(pacState.getAllPACDetailsFilters.year)}
                                    options={ValTypeOptions}
                                    onChange={(value) => dispatch(setGetAllValutazioniValType(value))}
                                />
                            </div>
                            {
                                (showM24Select || showBothSelect) &&
                                <div style={{ flex: '0.4' }}>
                                    <SelectCustom
                                        // key={pacState.getAllPACDetailsFilters.year || 'default'}
                                        placeholder={'Utente M24'}
                                        label="Utente M24"
                                        // value={String(pacState.getAllPACDetailsFilters.year)}
                                        options={yearOptions}
                                        onChange={(value) => dispatch(setGetAllValutazioniValM24User(value))}
                                    />
                                </div>
                            }

                            {
                                (showVisitsSelect || showBothSelect) &&
                                <div style={{ flex: '0.4' }}>
                                    <SelectCustom
                                        label="Utente Visite"
                                        // key={pacState.getAllPACDetailsFilters.year || 'default'}
                                        placeholder={'Utente Visite'}
                                        // value={String(pacState.getAllPACDetailsFilters.year)}
                                        options={yearOptions}
                                        onChange={(value) => dispatch(setGetAllValutazioniValVisitUser(value))}
                                    />
                                </div>
                            }

                            <div style={{ flex: '0.23', display: 'flex', alignItems: 'center' }}>
                                <span>
                                    <Button
                                        size={"lg"}
                                        iconPosition={"off"}
                                        variant={"outline"}
                                        label="Cerca"
                                        color={"blue"}
                                        onClick={
                                            () => {
                                                dispatch(GetAllValutazioni(valutazioniState.GetAllValutazioniFilters))
                                            }
                                        }
                                    />
                                </span>
                            </div>
                        </div>
                        {/* <div style={{ display: 'flex', justifyContent: 'right', flex: 0.3 }}>
                            <Pagination
                                numbResults={faseAvvio.GetAllFaseAvvioResponse ? faseAvvio.GetAllFaseAvvioResponse.total : 0}
                                pages={faseAvvio.GetAllFaseAvvioResponse?.totalPage || 1}
                                currentPage={faseAvvio.GetAllValutazioniFilters.page ? faseAvvio.GetAllValutazioniFilters.page : 0}
                                detailsResults={'clienti'}
                                setPage={
                                    (page) => {
                                        dispatch(setGetAllValutazioniFiltersPage(page))
                                        dispatch(GetAllFaseAvvio(faseAvvio.GetAllValutazioniFilters))
                                    }
                                }
                            />
                        </div> */}
                    </div>
                </div>
                {
                    showM24Select &&
                    <MonitoringValutazioniListM24 />
                }
                {
                    showVisitsSelect &&
                    <MonitoringValutazioniListVisits />
                }
                {
                    showBothSelect &&
                    <MonitoringValutazioniListVisitsM24 />
                }

            </div>
        </Layout>
    )
}